import TruckRequest from "../Utills/TruckRequest";



class TruckService {
    constructor(){
        this.controllerPath = "";
        this.isRelativePath = "";
        this.companyId = "";
    }

    setControllerPath(serviceControllerPath, isRelativePath)
    {
        this.controllerPath = serviceControllerPath;
        this.isRelativePath = isRelativePath;
    }

    setCompanyId(compId){
        this.companyId = compId;
    } 

    requestJson(methodName,params, afterResponse)
    {
        let url = this.buildUrl(methodName);

        if(params)
        {
            url += "?" + params;
        }
        TruckRequest.getJson(url,this.isRelativePath,afterResponse);
    }

    sendPostRequest(methodName,dataObject,afterResponse)
    {
        let url = this.buildUrl(methodName);
        //Here need to validate the data and encode the data
        TruckRequest.postData(url,this.isRelativePath,dataObject,afterResponse);
    }

    buildUrl(methodName){
        let url = `${this.controllerPath}/${methodName}`;
        return url;
    }
}

export default TruckService;